export default {
	notification_health: 'შეტყობინებების მდგომარეობა',
	notification_health_summary: 'შეჯამება',
	notification_health_loading: 'შეტყობინებების მდგომარეობის შემოწმება...',
	notification_health_refresh: 'განახლება',
	notification_health_fix: 'რა უნდა გაკეთდეს',
	notification_health_unavailable: 'შეტყობინებების მდგომარეობის ჩატვირთვა ვერ მოხერხდა',
	notification_health_healthy: 'წესრიგშია',
	notification_health_blocked: 'დაბლოკილი',
	notification_health_degraded: 'საჭიროებს ყურადღებას',
	notification_health_no_app_user: 'აპში შესვლა არ არის',
	notification_health_unknown: 'უცნობი',
	notification_health_app_version: 'აპის ვერსია',
	notification_health_last_delivery: 'ბოლო მიწოდება',
	notification_health_time_just_now: 'ახლახან',
	notification_health_time_minutes: '{count} წუთის წინ',
	notification_health_time_hours: '{count} საათის წინ',
	notification_health_time_days: '{count} დღის წინ',
	notification_health_time_unknown: 'უცნობი',
	notification_health_summary_healthy: 'შეტყობინებები უნდა მუშაობდეს',
	notification_health_summary_no_app_user: 'დამლაგებელმა მობილურ აპში შესვლა არ გააკეთა',
	notification_health_summary_blocked_no_token: 'Push ტოკენი აკლია — დამლაგებელმა უნდა გახსნას აპი და შევიდეს',
	notification_health_summary_blocked_off: 'შეტყობინებები გამორთულია აპში',
	notification_health_check_portal_contact_label: 'პორტალის კონტაქტი არსებობს',
	notification_health_check_portal_active_label: 'კონტაქტი აქტიურია',
	notification_health_check_portal_rooms_label: 'ოთახები მინიჭებულია',
	notification_health_check_portal_shifts_label: 'ცვლები მინიჭებულია',
	notification_health_check_app_user_label: 'მობილურ აპში შესულია',
	notification_health_check_push_token_label: 'Push ტოკენი დარეგისტრირებულია',
	notification_health_check_notification_mode_label: 'შეტყობინების რეჟიმი',
	notification_health_check_time_schedule_label: 'შეტყობინების დროის ფანჯარაშია',
	notification_health_check_ios_geo_filter_label: 'iOS მდებარეობის ფილტრი',
	notification_health_check_recent_push_attempt_label: 'ბოლო push მცდელობა (48ს)',
	notification_health_check_last_push_ignored_label: 'ბოლო სიგნალი არ გაიგზავნა',
	notification_health_check_recent_push_delivered_label: 'ბოლო push მიწოდება (48ს)',
	notification_health_detail_portal_contact_found: 'ნაპოვნია პორტალში',
	notification_health_detail_portal_contact_missing: 'კონტაქტის ჩანაწერი ვერ მოიძებნა',
	notification_health_detail_portal_active_active: 'აქტიური',
	notification_health_detail_portal_active_inactive: 'არააქტიური',
	notification_health_detail_portal_rooms_assigned: '{count} ოთახი',
	notification_health_detail_portal_rooms_none: 'ოთახები არ არის მინიჭებული',
	notification_health_detail_portal_shifts_assigned: '{count} ცვლა',
	notification_health_detail_portal_shifts_none: 'ცვლები არ არის მინიჭებული',
	notification_health_detail_app_user_logged_in: 'აპის ვერსია {version}, ბოლო სინქრონიზაცია {lastSync}',
	notification_health_detail_app_user_never: 'არასდროს შესულა',
	notification_health_detail_push_token_present: 'FCM ტოკენი არსებობს',
	notification_health_detail_push_token_empty: 'ტოკენი ცარიელია',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'მიმდინარე დრო განრიგის ფარგლებშია',
	notification_health_detail_time_schedule_outside: 'მიმდინარე დრო კონფიგურირებული განრიგის გარეთაა',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'ბოლო 48 საათში push მცდელობები არ არის',
	notification_health_detail_last_push_ignored: 'ბოლო push მოთხოვნა იგნორირდა (servik არ არის კონფიგურირებული სამუშაო ზონისთვის)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'ბოლო 48 საათში წარმატებული მიწოდებები არ არის',
	notification_health_fix_portal_contact: 'შექმენით ეს დამლაგებელი მომხმარებლების პანელში',
	notification_health_fix_portal_active: 'ჩართეთ აქტიური გადამრთველი ამ დამლაგებლისთვის',
	notification_health_fix_portal_rooms: 'მიანიჭეთ მინიმუმ ერთი ოთახი ამ დამლაგებელს',
	notification_health_fix_portal_shifts: 'მიანიჭეთ მინიმუმ ერთი ცვლა',
	notification_health_fix_app_user: 'დამლაგებელმა უნდა დააინსტალიროს აპი და შევიდეს ამ ტელეფონის ნომრით',
	notification_health_fix_push_token: 'სთხოვეთ დამლაგებელს გახსნას აპი, iOS პარამეტრებში დაუშვას შეტყობინებები და თავიდან შევიდეს',
	notification_health_fix_notification_mode: 'აპში შეტყობინების რეჟიმი გამორთულიდან ყოველთვის-ზე შეცვალეთ',
	notification_health_fix_time_schedule: 'დაელოდეთ დაგეგმილ ფანჯარას ან რეჟიმი ყოველთვის-ზე შეცვალეთ',
	notification_health_fix_ios_geo_filter: 'დამლაგებელი შეტყობინების ზონის გარეთაა — სთხოვეთ აპი ადგილზე გახსნას',
	notification_health_fix_last_push_ignored: 'შეამოწმეთ სამუშაო ზონის servik კონფიგურაცია იმ ოთახისთვის, რომელმაც სიგნალი გამოიწვია',
	notification_health_fix_recent_push_delivered_filters: 'შეამოწმეთ შეტყობინების ფილტრები ან მოწყობილობის პარამეტრები',
	notification_health_fix_recent_push_delivered_token: 'ჯერ push ტოკენი დარეგისტრირეთ',
	notification_health_mode_on: 'ყოველთვის',
	notification_health_mode_off: 'გამორთული',
	notification_health_mode_time: 'დროის მიხედვით',
	notification_health_mode_location: 'მდებარეობის მიხედვით',
	notification_health_filter_on: 'ჩართული',
	notification_health_filter_off: 'გამორთული',
};
